import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight, ChevronDown } from "lucide-react";
import { SITE } from "@/data/site";
import { HERO_SLIDES } from "@/data/homeMedia";

export const HomeHero = () => {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((n) => (n + 1) % HERO_SLIDES.length), 6500);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="relative h-[86vh] min-h-[560px] md:h-[92vh] overflow-hidden" data-testid="home-hero">
      {HERO_SLIDES.map((s, n) => (
        <div
          key={s.src}
          className="absolute inset-0 slide-fade"
          style={{ opacity: n === i ? 1 : 0 }}
          aria-hidden={n !== i}
        >
          <img
            src={s.src}
            alt={s.alt}
            className={`w-full h-full object-cover ${n === i ? "kenburns" : ""}`}
            loading={n === 0 ? "eager" : "lazy"}
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-t from-[#0A1D3A] via-[#0A1D3A]/55 to-[#0A1D3A]/25" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A1D3A]/85 via-transparent to-transparent" />

      <div className="relative h-full max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col justify-end pb-16 md:pb-24">
        <div className="max-w-2xl">
          <p className="text-[11px] uppercase tracking-[0.34em] text-[#E4C67A]">
            {SITE.region} · Kirra &amp; Hervey Bay
          </p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.03] text-[#FCFAF6] mt-5">
            Save 10% when you book
            <br className="hidden sm:block" /> directly with PARADISIO RESORTS
          </h1>
          <span className="block h-px w-28 bg-gradient-to-r from-[#E4C67A] to-transparent mt-8" />
          <p className="text-base text-[#FCFAF6]/85 leading-relaxed mt-7 max-w-lg">
            Four privately owned holiday homes on the Queensland coast: absolute beachfront at Kirra, plus a
            one-bedroom, a studio and an ocean-view apartment at Urangan, Hervey Bay. No platform, no booking
            fees, just Robert.
          </p>

          <div className="flex flex-wrap items-center gap-4 mt-10">
            <a
              href="#properties"
              className="inline-flex items-center gap-3 bg-[#E4C67A] text-[#0F2A52] px-7 py-4 text-sm font-medium hover:-translate-y-1 hover:shadow-2xl transition-transform duration-200"
              data-testid="hero-view-properties-btn"
            >
              Explore our properties <ArrowRight size={16} />
            </a>
            <Link
              to="/enquire"
              className="inline-flex items-center gap-3 border border-[#FCFAF6]/45 text-[#FCFAF6] px-7 py-4 text-sm hover:bg-[#FCFAF6]/12 transition-colors duration-200"
              data-testid="hero-enquire-btn"
            >
              Enquire about a stay
            </Link>
            <a
              href={`tel:${SITE.phone}`}
              className="inline-flex items-center gap-2 text-sm text-[#FCFAF6]/90 px-2 py-4 hover:text-[#E4C67A] transition-colors duration-200"
              data-testid="hero-call-btn"
            >
              <Phone size={16} /> {SITE.phoneDisplay}
            </a>
          </div>
        </div>

        <div className="flex items-end justify-between gap-6 mt-12">
          <div className="flex items-center gap-3" data-testid="hero-slide-dots">
            {HERO_SLIDES.map((s, n) => (
              <button
                key={s.src}
                onClick={() => setI(n)}
                aria-label={`Show slide ${n + 1}`}
                data-testid={`hero-dot-${n}`}
                className={`h-[3px] transition-all duration-500 ${
                  n === i ? "w-12 bg-[#E4C67A]" : "w-6 bg-[#FCFAF6]/45 hover:bg-[#FCFAF6]/80"
                }`}
              />
            ))}
            <span className="text-[11px] uppercase tracking-[0.24em] text-[#FCFAF6]/70 ml-3 hidden sm:block">
              {HERO_SLIDES[i].caption}
            </span>
          </div>
          <ChevronDown size={22} className="text-[#FCFAF6]/70 scroll-hint hidden md:block" />
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
